<template>
  <div class="users-table">
    <template v-if="activeSearch">
      <span>Búsqueda Actual: </span><strong>{{ activeSearch }}</strong>
    </template>
    <template v-else>
      <span>Mostrando todos los usuarios</span>
    </template>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>RUT</th>
          <th>Inscrito El</th>
          <th v-if="!hideOrganization">
            Organizaciones
          </th>
          <th v-if="!hideUserRole">
            Rol
          </th>
          <th width="1">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody v-if="users.length">
        <tr v-for="user in filteredUsers" :key="`user-key-${user.id}`">
          <td>
            <router-link :to="userDetailsRoute(user)">
              {{ user.given_name }} {{ user.family_name }}
            </router-link>
          </td>
          <td nowrap>
            {{ user.claveunica_id }}
          </td>
          <td>{{ user.created_at }}</td>
          <td v-if="!hideOrganization">
            <span v-for="organization in user.organizations" :key="organization.uuid">
              <router-link
                v-if="userViewOrganization(organization)"
                class="badge badge-primary"
                :to="userViewOrganization(organization) ? organizationDetailsRoute(organization) : '#'">
                {{ organization.name }} - {{ organization.source === 'midas' ? organization.code : organization.rut }}
              </router-link>
            </span>
          </td>
          <td v-if="!hideUserRole">
            {{ userRoleName(user.type) }}
          </td>
          <td nowrap>
            <button v-if="userCanEdit(user)" class="btn btn-sm btn-success" @click.prevent="handleClickEditUser(user)">
              Editar
            </button>
            <button v-if="userCanDelete(user)" class="btn btn-sm btn-danger" @click.prevent="handleClickDeleteUser(user)">
              Eliminar
            </button>
            <slot v-if="userCanDelete(user, true)" :user="user" name="additional-actions" />
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="table-warning text-center">
          <td :colspan="colspanCount">
            No hay usuarios disponibles
          </td>
        </tr>
      </tbody>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :hide-on-single-page="true"
      class="text-center"
      :current-page="pagination.page"
      :total="pagination.total"
      :page-size="pagination.perPage"
      @current-change="handlePaginationChange" />
    <el-dialog
      :width="dialogWidth"
      :title="`Nuevo ${title}`"
      :visible="userToEdit !== null"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseUserDialog">
      <user-form
        v-if="userToEdit"
        :user="userToEdit"
        :type="userToEdit.type || type"
        :default-organization="[]"
        @user-saved="handleUserSaved" />
    </el-dialog>
  </div>
</template>

<script>
import UserForm from '@/components/user/UserForm';
import userTypes from '@/assets/constants/user-roles';

export default {
  name: 'UserTable',
  components: { UserForm },
  props: {
    users: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    pagination: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    activeSearch: {
      type: String,
      default: ''
    },
    defaultOrganization: {
      type: Object,
      default() {
        return {};
      }
    },
    hideOrganization: {
      type: Boolean,
      default: false
    },
    hideUserRole: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userToEdit: null,
      userToEditType: this.type
    };
  },
  computed: {
    dialogWidth() {
      return this.$store.getters.windowWidth < 992 ? '80%' : '50%';
    },
    filteredUsers() {
      const search = this.msg.toLowerCase();
      if (!search) return this.users;
      return this.users.filter(user => {
        return user.given_name.toLowerCase().indexOf(search) >= 0;
      });
    },
    colspanCount() {
      let count = 7;
      if (this.hideOrganization) count--;
      if (this.hideUserRole) count--;
      return count;
    }
  },
  methods: {
    userViewOrganization(organization) {
      if (this.$store.getters.hasRole('admin')) {
        return true;
      }

      let returned = false;
      this.$store.getters.user.organizations.forEach(org => {
        if (org.code == organization.code) {
          returned = true;
        }
      });

      return returned;
    },
    userCanEdit(user) {
      return this.$store.getters.hasRole('admin') || this.$store.getters.user.id === user.id || this.userIsDependant(user);
    },
    userCanDelete(user, isquitar = false) {
      if (isquitar && this.$store.getters.hasRole('dispenser_admin') && user.id !== this.$store.getters.user.id) {
        return true;
      }

      return user.id !== this.$store.getters.user.id && (
        this.$store.getters.hasRole('admin') || this.userIsDependant(user)
      );
    },
    userIsDependant(user) {
      return this.$store.getters.user.type === 'dispenser_admin' && user.type === 'dispenser';
    },
    userRoleName(type) {
      return userTypes.find(t => t.type === type).name;
    },
    handleClickDeleteUser(user) {
      this.$emit('delete-user', user);
    },
    handleClickEditUser(user) {
      this.userToEdit = Object.assign(JSON.parse(JSON.stringify(user)));
    },
    userDetailsRoute(user) {
      return `/users/${user.id}`;
    },
    organizationDetailsRoute(organization) {
      return `/organizations/${organization.source}/${organization.uuid}`;
    },
    handleClickAddUser(userOptions = {}) {
      this.userToEdit = {
        // Issue #159
        // organizations: Object.keys(this.defaultOrganization).length ? [{ uuid: this.defaultOrganization.uuid }] : [],
        organizations: [],
        ...userOptions
      };
    },
    handleUserSaved(user) {
      this.$message({
        type: 'success',
        message: 'Usuario guardado'
      });
      this.handleCloseUserDialog();
      this.$emit('save-user', user);
    },
    handleCloseUserDialog() {
      this.userToEdit = null;
    },
    handlePaginationChange(page) {
      this.$emit('page-change', page);
    }
  }
};
</script>

<style lang="scss">
.users-table {
  td:last-child:not(:first-child) {
    button {
      margin-left: $--spacing-1;
    }
  }
  td {
    .badge {
      margin-right: $--spacing-1;
    }
  }
}
</style>
